import { render } from "./Users.vue?vue&type=template&id=32dd99aa"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data/dev.bl8m.it/vhosts/clients/client0/web144/web/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__